import { DomainSchema } from '@multitec/domain'
import { useQuery } from 'react-query'
import { z } from 'zod'

import { Base } from '../base'

const BASE_URL = '/entity/storages'

class Search extends Base {
  private response = z.array(
    z.object({
      ...DomainSchema.StorageItem.shape,
      Item: DomainSchema.Product,
      statusLevel: z.number(),
    }),
  )

  handle = (id?: string) => {
    return useQuery(['storage-item', 'search', { id }], async () => {
      if (!id) return []
      const { data } = await this.axios.get(`${BASE_URL}/${id}/items`)
      return this.response.parse(data.result)
    })
  }
}

class UpdateRules extends Base {
  private body = z.object({
    items: z.array(
      DomainSchema.StorageItem.pick({
        item_id: true,
        rule_min_quantity: true,
      }),
    ),
  })

  private response = z.array(DomainSchema.StorageItem)

  handle = async (id: string, body: z.infer<typeof this.body>) => {
    const { data } = await this.axios.post(
      `${BASE_URL}/${id}/items/rules`,
      body,
    )
    return this.response.parse(data.result)
  }
}

export default class extends Base {
  Search = new Search(this.axios).handle
  UpdateRules = new UpdateRules(this.axios).handle
}
